import {ApplicationEdit} from "../../../../../components/layout/shared/applicant/applicant_edit";

export const RecruitmentApplicationEditPage = () => {
    return (
        <>
            <ApplicationEdit/>
        </>
    );
};